import { Textarea, VerticalContainer } from '@/components';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import { WarningBanner } from '@/caregiverSpace/shared/ui';

type CaregiverCallConfirmationViewProps = {
    verificationText: string;
    setVerificationText: (text: string) => void;
};

export const HandledByOtherView = ({
    verificationText,
    setVerificationText,
}: CaregiverCallConfirmationViewProps) => {
    return (
        <VerticalContainer spacing="sm">
            <WarningBanner
                title={R.BookedByAnotherCaregiver}
                description={R.StartConsultationApproval}
            />
            <Textarea
                className="py-2 focus:py-2"
                onChangeText={setVerificationText}
                maxHeight={200}
                value={verificationText}
            />
            <p>{R.ApproveConsultationOverrideActionExplanation}</p>
        </VerticalContainer>
    );
};
